import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "flex flex-col items-center justify-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-10px text-gray-lp-300 mt-2" }
const _hoisted_5 = { class: "text-10px text-gray-lp-800" }
const _hoisted_6 = { class: "text-12px" }
const _hoisted_7 = { class: "text-12px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_loading = _resolveComponent("main-loading")!
  const _component_card = _resolveComponent("card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataProducts, (product, index) => {
    return (_openBlock(), _createBlock(_component_card, {
      key: index,
      isShadow: false,
      class: `relative pt-3 px-2 ${!_ctx.firstRender ? 'cursor-pointer' : ''}`,
      customClass: `${product.statusSelect && (!_ctx.isEmbargo && !product.isEmbargo)? ' bg-pink-lp-500 border border-red-lp-1500' : 'border border-gray-lp-400'} `,
      style: {"height":"180px"},
      onClick: ($event: any) => (!_ctx.firstRender && !_ctx.isDisabled && product.statusActive && (!_ctx.isEmbargo && !product.isEmbargo) ? _ctx.setActive(index, product.name) : () => {}),
      isDisabled: _ctx.isDisabled || !product.statusActive || _ctx.isEmbargo || product.isEmbargo
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_main_loading, { key: 0 }))
          : (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("img", {
                  class: "text-gray-lp-600",
                  src: 
            require(`@/app/ui/assets/svg/product-logo/${product.icon}-${product.statusCard && product.statusActive && (!_ctx.isEmbargo && !product.isEmbargo) ? 'active' : 'inactive'}.svg`)
            ,
                  alt: "products-cards",
                  width: "100",
                  height: "18"
                }, null, 8, ["src"]),
                _withDirectives(_createVNode("div", {
                  class: `text-10px font-semibold mt-2 text-center`,
                  style: `color: ${_ctx.isEmbargo || product.isEmbargo ? '' : product.color}`
                }, null, 4), [
                  [_directive_sanitize_html, product.motto]
                ]),
                _createVNode("div", _hoisted_3, [
                  _createVNode("p", _hoisted_4, _toDisplayString(product.statusCard && (!_ctx.isEmbargo && !product.isEmbargo) 
                  ? _ctx.hideKgs ? product.price?.toString()?.replace(/\/(?:10kg awal|30kg awal|kg)/g, '') : product.price 
                  : _ctx.version === 'v1' 
                    ? _ctx.$t('bookingShipment.product.zeroCurrency') 
                    : _ctx.isEmbargo || product.isEmbargo 
                      ? _ctx.$t("booking.productPoster.shippingEmbargo")
                      : _ctx.$t('bookingV3.productType.card.labelAvailable')), 1),
                  _createVNode("p", _hoisted_5, _toDisplayString(product.statusCard && (!_ctx.isEmbargo && !product.isEmbargo) ? product.sla : _ctx.version === 'v1' ? "-" : ""), 1)
                ])
              ]),
              _createVNode("div", {
                class: "absolute bottom-0 left-0 top-12 w-full rounded-b-md text-center py-1 font-medium",
                style: `
            background-color: ${_ctx.isEmbargo || product.isEmbargo ? '#a7a8aa' : product.color}; 
            background: linear-gradient(180deg, ${_ctx.isEmbargo ? '#ffffff' : product.footer.firstColor} -109.09%, ${_ctx.isEmbargo || product.isEmbargo ? '#d4d5d8' : product.footer.secondColor} 100%);
            color: ${_ctx.isEmbargo || product.isEmbargo ? '#a7a8aa' : product.color};
            margin-top: 80px;
            `
              }, [
                _createVNode("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.$t('bookingShipment.product.descAgent')) + " ", 1),
                  _createVNode("strong", null, _toDisplayString(product.statusCard && (!_ctx.isEmbargo && !product.isEmbargo) ? product.discountAgentPrecentage : "-"), 1)
                ]),
                _createVNode("strong", _hoisted_7, _toDisplayString(product.statusCard && (!_ctx.isEmbargo && !product.isEmbargo) ? _ctx.hideKgs ? product.discountAgentNominal?.replace(/\/(?:10kg awal|30kg awal|kg)/g, '') : product.discountAgentNominal : _ctx.version === 'v1' ? _ctx.$t('bookingShipment.product.zeroCurrency') : '-'), 1)
              ], 4)
            ]))
      ]),
      _: 2
    }, 1032, ["class", "customClass", "onClick", "isDisabled"]))
  }), 128))
}